import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../rewards/reducer";

import {
  getCheapestLodgingRoomProduct,
  getPackageSelectedLodging,
  getPackageRatesById,
} from "../../reducer/selectors";
import { DesktopHotelPhotoModal } from "./component";
import {
  getPackageNightCountBasedOnAvailability,
  getTravelersCount,
} from "../../../availability/reducer";

const mapStateToProps = (state: IStoreState) => {
  return {
    lodging: getPackageSelectedLodging(state) || undefined,
    roomProduct: getCheapestLodgingRoomProduct(state),
    rewardsKey:
      getSelectedAccountReferenceIdIfRedemptionEnabled(state) || undefined,
    nightCount: getPackageNightCountBasedOnAvailability(state),
    packageRatesById: getPackageRatesById(state),
    travelersCount: getTravelersCount(state),
  };
};

export const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type DesktopHotelPhotoModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedDesktopHotelPhotoModal = connector(
  DesktopHotelPhotoModal,
);
